/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import "./radio.scss";

const Radio = ({ inputRef, ...props }) => {
  return (
    <label className="radio">
      <input ref={inputRef} type="radio" {...props} />
      <span className="radio__mark" />
    </label>
  );
};

export default Radio;
